jQuery(document).ready(function($) {
    'use strict';

    var flyout = $('#flyout-menu');
    var button = $('.flyout-trigger');
    var header = $('.header');


    $(document).on('click', '.flyout-trigger', function() {
        flyout.toggleClass('open');
        button.toggleClass('menu-open');
    });
});
